import { render, staticRenderFns } from "./StudentProfileNotifications.vue?vue&type=template&id=41e4e8da&scoped=true&"
import script from "./StudentProfileNotifications.vue?vue&type=script&lang=js&"
export * from "./StudentProfileNotifications.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileNotifications.vue?vue&type=style&index=0&id=41e4e8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e4e8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VIcon})
